export const TITLE = "Time in Stage";
export const SUBTITLE = "Days each opportunity has sat in its stage";
export const EMPTY_TITLE = "No opportunities yet";
export const EMPTY_BODY = "Stage aging appears once you start tracking opportunities.";
export const TRACKED_OPPORTUNITIES_PATH = "/capture/tracked-opportunities";
export const BAR_COLOR = "var(--color-middle-purple)";
export const BAR_TRACK_COLOR = "var(--token-surface-gray-150)";
